export default {
    title: 'Insight',
    'create-button': 'Create new insight',
    'edit-button': 'Edit insight',
    'title-input-label': 'Insight title',
    'empty-list': 'Empty insights list',
    'filters-title': 'Results range:',
    metrics: {
        'conversion-rate': '{rate}% completed steps',
        'drop-off-rate': '{rate}% dropped off',
        users: '{count} user | {count} users',
        show: 'Show results',
        hide: 'Hide results',
    },
    'block-results': 'Save changes to see results',
    fields: {
        'workflow-id': 'Query tasks from workflow',
    },
}
